import Axios from "axios";
import { useWarningModal } from "GlobalStore/warningModal";

if (typeof window !== "undefined") {
	// only attach interceptors in browser
	Axios.interceptors.response.use(
		(response) => {
			const { setBody } = useWarningModal.getState();

			if (response?.data?.meta?.code === 555) {
				setBody({ code: 555 });
			}

			return response;
		},
		(error) => {
			const { setBody } = useWarningModal.getState();

			if (error?.response?.data?.meta?.code === 555 || error?.response?.status === 555) {
				setBody({ code: 555 });
			}

			return Promise.reject(error); // still reject so caller can handle if needed
		},
	);
}

export default Axios;
